<script setup lang="ts">
  import useIcons from '@/composables/useIcons'

  defineProps({
    actionText: {
      type: String,
      required: true,
    },
  })

  const emit = defineEmits(['action'])

  const { examIcon } = useIcons()

  const handleAction = () => {
    emit('action')
  }
</script>

<template lang="pug">
.exam-action
  .exam-action-wrapper
    .exam-action-content
      h4.ketch-font-bold {{ $t('courses.examSimulation.title') }}
      h5 {{ $t('courses.examSimulation.testYourKnowledge') }}
    .action-wrapper(@click='handleAction')
      h5 -> {{ actionText }}
  .exam-icon
    img(:src='examIcon', width='120px', height='120px')
</template>

<style lang="postcss" scoped>
  .exam-action {
    @apply ketch-flex ketch-justify-between ketch-py-c10 ketch-pl-c10;
    @apply ketch-bg-content-background-color ketch-rounded-normal ketch-shadow-content-shadow;
    @apply xs1:ketch-py-c15 xs1:ketch-pl-c15 sm:ketch-items-center sm:ketch-border-r sm:ketch-border-border-color;
    @apply sm:ketch-bg-transparent sm:ketch-rounded-none sm:ketch-shadow-none;

    .exam-action-wrapper {
      @apply ketch-flex ketch-flex-col ketch-justify-between sm:ketch-h-full;

      .action-wrapper {
        @apply ketch-cursor-pointer;
      }
    }

    .exam-icon {
      @apply ketch-flex ketch-items-end ketch-justify-end ketch--my-c10;

      img {
        @apply ketch-w-[120px] ketch-h-[130px] ketch-rounded-r-large sm:ketch-rounded-none;
      }
    }

    &:not(.purchased-variant) {
      @apply ketch-border ketch-rounded-normal ketch-shadow-content-shadow sm:ketch-bg-content-background-color;

      .exam-icon {
        img {
          @apply sm:ketch-rounded-r-normal;
        }
      }
    }
  }
</style>
